import { PaginationProps, SortDirection } from 'utilities'

export type ProductsSearchProps = {
  productName: string
  agreementName: string
  projectName: string
  brandName: string
  tags: string
  minSKUs: number
  maxSKUs: number
  startDate: string
  endDate: string
}

export enum ProductsTableSortProps {
  NAME = 'name',
  STORE_NAME = 'brand.name',
  CREATED_DATE = 'createdDate',
  TAGS = 'tags'
}

export type ProductTablePaginationProps = PaginationProps<ProductsTableSortProps>

export const initialProductsSearchProps: ProductsSearchProps = {
  productName: '',
  agreementName: '',
  projectName: '',
  brandName: '',
  tags: '',
  minSKUs: null,
  maxSKUs: null,
  startDate: null,
  endDate: null
}

export const initialProductTablePaginationProps: ProductTablePaginationProps = {
  page: 0,
  size: 15,
  sortProp: ProductsTableSortProps.NAME,
  sortDirection: SortDirection.ASC,
  totalElements: 0,
  totalPages: 0
}
